import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Multimedia View Config"})
export default class MultimediaViewConfig {

	@Input({type: InputType.COLOR, title: "Video Player Background"})
	public videoBackgroundColor: string;

	@Input({type: InputType.COLOR, title: "Transcript highlight color"})
	public highlightColor: string;

	@Input({
		type: InputType.UNIT,
		title: "Transcript Max Height",
		description: "This might also be externally controlled"
	})
	public transcriptMaxHeight: string;

	@Input({
		type: InputType.UNIT,
		title: "Video Max Height",
		description: "This might also be externally controlled"
	})
	public videoMaxHeight: string;

}



// WEBPACK FOOTER //
// ./src/common/views/multimedia/MultimediaViewConfig.ts